var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseMini({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-pause",
    "data-name": "Icon ionic-ios-pause",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M12.613,22.75H9.407A.4.4,0,0,1,9,22.35V7.15a.4.4,0,0,1,.407-.4h3.206a.4.4,0,0,1,.407.4v15.2A.4.4,0,0,1,12.613,22.75Z",
    transform: "translate(-9 -6.75)",
    fill: "#777272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M24.988,22.75H21.782a.4.4,0,0,1-.407-.4V7.15a.4.4,0,0,1,.407-.4h3.206a.4.4,0,0,1,.407.4v15.2A.4.4,0,0,1,24.988,22.75Z",
    transform: "translate(-12.596 -6.75)",
    fill: "#777272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseMini);
export default __webpack_public_path__ + "static/media/pause-mini.bf39ad75822ff67badbca2736ec37d72.svg";
export { ForwardRef as ReactComponent };